import React, { useState, useEffect } from "react";
import { MenuBar } from "../../components/MenuBar";
import Address from "../../components/Address";
import { getCertification } from "../../services/CertificationAPI";
import CertificationCard from "../../components/CertificationCard";
import "../ContentFrame.css";
import "../Main.css";

export const Certification = () => {
    let [cardList, setCardList] = useState([]);

    useEffect(() => {
        let cards = [];
        getCertification().then((certifications) => {
            certifications.map((certification) => {
                cards.push(
                    <CertificationCard
                        key={certification["id"]}
                        image={certification["imageUrl"]}
                        title={certification["name"]}
                    />
                );
                setCardList(cards);
            });
        });
    }, []);

    return (
        <div className="main_container">
            <MenuBar selected_page={3} />

            <div className="common_frame_container">
                <div className="common_content_container">
                    <div style={{ width: "100%", height: "100px" }}></div>
                    <span className="page_title">인증서</span>
                    <div className="certificate_grid_container">{cardList}</div>
                    <div style={{ width: "100%", height: "100px" }}></div>
                </div>
            </div>

            <Address />
        </div>
    );
};
